module.exports = __webpack_public_path__ + "img/chordMate-screen.fbcf8124.png";